import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import FrameSelector from '../components/photoTools/FrameSelector'

const PhotoFramePage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="Frame Tool"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Frame Tool
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Dodaj ramkę wokół zdjęcia
          </Typography>
        </Box>

        <FrameSelector />
      </Container>
    </>
  )
}

export default PhotoFramePage
